import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';
import { Link } from 'react-router';

import Icon from '../icon/Icon';

require('./style.scss');

const Pagination = (props) => {
  const pageStart = pages =>
    props.currentPage - pages > 1 ? props.currentPage - pages : 1;
  const pageEnd = pages =>
    props.currentPage + pages < props.totalPages + 1 ? props.currentPage + pages : props.totalPages;
  const isVisible = (pages, currentPage) =>
    currentPage < pageStart(pages) || currentPage > pageEnd(pages);

  const pageVisibility = page => ({
    'hidden-xs': isVisible(2, page),
    'hidden-sm': isVisible(3, page),
    'hidden-md': isVisible(5, page),
    'hidden-lg': isVisible(6, page),
  });

  return (
    <div className="pagination">
      <Link
        className={Classnames('pagination-arrow', { disabled: props.currentPage <= 1 })}
        disabled={props.currentPage <= 1}
        to={props.currentPage > 1 ?
            `${props.urlPrefix}/${props.currentPage - 1}` :
            `${props.urlPrefix}/1`}
      >
        <Icon name="angle-left" /><span className="hidden-xs hidden-sm hidden-md"> Previous Page</span>
      </Link>

      {_.range(1, props.totalPages + 1).map(page =>
        <Link
          key={page}
          className={Classnames('pagination-page', pageVisibility(page))}
          activeClassName="active"
          to={`${props.urlPrefix}/${page}`}
        >
          {page}
        </Link>)}

      <Link
        className={Classnames('pagination-arrow', { disabled: props.currentPage >= props.totalPages })}
        disabled={props.currentPage >= props.totalPages}
        to={props.currentPage < props.totalPages ?
            `${props.urlPrefix}/${props.currentPage + 1}` :
            `${props.urlPrefix}/${props.totalPages}`}
      >
        <span className="hidden-xs hidden-sm hidden-md">Next Page </span><Icon name="angle-right" />
      </Link>
    </div>);
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number.isRequired,
  urlPrefix: PropTypes.string.isRequired,
};

Pagination.defaultProps = {
  currentPage: 1,
};

module.exports = Pagination;



// WEBPACK FOOTER //
// ./app/components/common/pagination/Pagination.jsx